module.exports = require('./lib/autoBind');
